// ══════════════════════════════════════════════════════════════
// COMPASS – User Signature State Model (US-013)
// ══════════════════════════════════════════════════════════════

import { UserSignatureDto } from '../../api/models/user-signature-dto';

/** The signed-in Compliance Officer's own signature, embedded in the KYC report of every process they validate. */
export interface UserSignatureState {
  /** The active signature; null when none is stored yet (or not loaded). */
  signature: UserSignatureDto | null;
  loaded: boolean;
  loading: boolean;
  /** The last load failed: the profile offers a retry instead of saying there is no signature. */
  loadError: string | null;
  /** The backend refused (403): the user is no Compliance Officer in any company, so the profile has no signature. */
  forbidden: boolean;
  uploading: boolean;
}

export const initialUserSignatureState: UserSignatureState = {
  signature: null,
  loaded: false,
  loading: false,
  loadError: null,
  forbidden: false,
  uploading: false,
};
